// extracted by mini-css-extract-plugin
module.exports = {"label":"label__1q3RI","textarea":"textarea__3wKo8"};